/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import Button from '@mui/material/Button'
import HomeIcon from '@mui/icons-material/Home'
import { go, routes } from '../location'
import Card from '../components/Card'

import brain from './about/brain-organic.svg'
import cap from './about/cap.svg'
import gplv3 from './about/gplv3.svg'
import mouse from './about/mouse.svg'
import palette from './about/palette.svg'
import globe from './about/globe.svg'
import { LEVELS, log } from '../logs'
import { translations } from '../nls'

const AboutScreen = props => {
  log('AboutScreen', LEVELS.INFO, props)
  const { homeClick } = props
  const intl = useIntl()
  const version = process.env.REACT_APP_VERSION
  return (
    <div className='about-screen'>
      <p style={{ padding: '10px', fontWeight: 600 }}>{intl.formatMessage({ id: 'about.about' })}</p>
      <div style={{ overflowY: 'auto', width: '100%', display: 'flex', justifyContent: 'center' }}>
        <table>
          <tbody>
            <tr>
              <td rowSpan={2}>
                <div className='about-card'>
                  <Card
                    image={brain}
                    transform={{}}
                    flipped
                    size={100}
                  />
                </div>
              </td>
              <td className='about-category'>{intl.formatMessage({ id: 'about.versionTitle' })}</td>
            </tr>
            <tr>
              <td><p>{version}</p></td>
            </tr>            <tr>
              <td rowSpan={2}>
                <div className='about-card'>
                  <Card
                    image={mouse}
                    transform={{}}
                    flipped
                    size={100}
                  />
                </div>
              </td>
              <td className='about-category'>{intl.formatMessage({ id: 'about.devTitle' })}</td>
                             </tr>
            <tr>
              <td><p>Lukas Laag</p></td>
            </tr>
            <tr>
              <td rowSpan={2}>
                <div className='about-card'>
                  <Card
                    image={gplv3}
                    transform={{}}
                    flipped
                    size={100}
                  />
                </div>
              </td>
              <td className='about-category'>{intl.formatMessage({ id: 'about.copyrightTitle' })}</td>
            </tr>
            <tr>
              <td><p dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'about.copyrightValue' }) }} /></td>
            </tr>
            <tr>
              <td rowSpan={2}>
                <div className='about-card'>
                  <Card
                    image={palette}
                    transform={{}}
                    flipped
                    size={100}
                  />
                </div>
              </td>
              <td className='about-category'>{intl.formatMessage({ id: 'about.artTitle' })}</td>
            </tr>
            <tr>
              <td><p dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'about.artValue' }) }} /></td>
            </tr>
            <tr>
              <td rowSpan={2}>
                <div className='about-card'>
                  <Card
                    image={globe}
                    transform={{}}
                    flipped
                    size={100}
                  />
                </div>
              </td>
              <td className='about-category'>{intl.formatMessage({ id: 'about.translationsTitle' })}</td>
            </tr>
            <tr>
              <td>
                <div class='translations'>
                  <table>
                    <thead>
                      <tr>
                        <th>{intl.formatMessage({ id: 'about.trLanguage' })}</th>
                        <th>{intl.formatMessage({ id: 'about.trTranslator' })}</th>
                      </tr>
                    </thead>
                    {Object.values(translations).map(({ flag, language, translator }, index) => {
                      return (
                        <tr key={index}>
                          <td><div class='language'>{flag} {language}</div></td>
                          <td>{translator}</td>
                        </tr>
                      )
                    })}
                  </table>
                </div>
              </td>
            </tr>
            <tr>
              <td rowSpan={2}>
                <div className='about-card'>
                  <Card
                    image={cap}
                    transform={{}}
                    flipped
                    size={100}
                  />
                </div>
              </td>
              <td className='about-category'>{intl.formatMessage({ id: 'about.thanksTitle' })}</td>
            </tr>
            <tr>
              <td><p dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'about.thanksValue' }) }} /></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ paddingTop: '20px', paddingBottom: '20px', width: '100%', textAlign: 'center' }}>
        <Button
          variant='contained'
          startIcon={<HomeIcon />}
          onClick={homeClick}
        >{intl.formatMessage({ id: 'common.home' })}
        </Button>
      </div>
    </div>
  )
}

AboutScreen.displayName = 'AboutScreen'

const mapStateToProps = () => ({})
const mapDispatchToProps = (dispatch) => ({
  homeClick: () => {
    dispatch(go(routes.HOME))
  }
})
export default connect(mapStateToProps, mapDispatchToProps)(AboutScreen)
